var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "body" },
    [
      (_vm.action == "REJECT" ||
        _vm.action == "PART_REJECT" ||
        _vm.action == "CQSISSUED") &&
      _vm.auditStatus == null
        ? _c(
            "el-card",
            { attrs: { header: _vm.header } },
            [
              _vm.subtitle
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bolder",
                        "font-size": "16px",
                        margin: "0 16px 10px",
                      },
                    },
                    [_vm._v(_vm._s(_vm.subtitle))]
                  )
                : _vm._e(),
              _c(
                "el-form",
                { attrs: { "label-width": "80px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("common.opinion") + ":" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", autosize: { minRows: 5 } },
                        model: {
                          value: _vm.remark,
                          callback: function ($$v) {
                            _vm.remark = $$v
                          },
                          expression: "remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-row"),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "1em" },
                  attrs: { type: "flex", justify: "center" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "warning" },
                      on: {
                        click: function ($event) {
                          return _vm.audit(_vm.action)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.submit")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.auditStatus == "SUCCESS"
        ? _c(
            "div",
            [
              _c("el-row", { attrs: { type: "flex", justify: "center" } }, [
                _c("img", {
                  attrs: {
                    src: require("../../assets/img/auditSuccess.png"),
                    alt: "SUCCESS",
                  },
                }),
              ]),
              _c("el-alert", { attrs: { center: "", type: "success" } }, [
                _vm._v(_vm._s(_vm.$t("common.auditSuccess"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.auditStatus == "ERROR"
        ? _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c("el-row", { attrs: { type: "flex", justify: "center" } }, [
                _c("img", {
                  attrs: {
                    src: require("../../assets/img/auditError.png"),
                    alt: "ERROR",
                  },
                }),
              ]),
              _c("el-alert", { attrs: { center: "", type: "error" } }, [
                _vm._v(_vm._s(_vm.msg)),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }